import { Switch } from "antd";
import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import deletepic from "../../assets/delete.svg";
import editpic from "../../assets/edit.svg";
import AddLocationModal from "../../Components/AddLocationModal/AddLocationModal";
import MyVerticallyCenteredModal from "../../Components/DeleteModal/DeleteModal";
import EditLocationModal from "../../Components/EditLocationModal/EditLocationModal";
import Loader from "../../Components/Loader/Loader";
import { StoreLocationAPI } from "../../Utils/Api/UserProfile";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { userId } from "../../Utils/LocalStorage";

const AddStoreLocation = () => {
  const [storeInfoData, setstoreInfo] = useState([]);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteID] = useState("");
  const [editInfo, setEditInfo] = useState("");
  const [key, setKey] = useState(false);
  const [editkey, setEditKey] = useState(false);
  const [locationStatus, setLocationStatus] = useState({});

  //modal
  const [modalShow, setModalShow] = useState(false);
  const [modalShowLocation, setModalShowLocation] = useState(false);
  const [modalEditLocation, setModalEditLocation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const xyz = (val) => {
    if (val === true) {
      setModalShowLocation(false);
      StoreInfoAPIHandler();
      setKey(false);
    }
  };
  const abc = (val) => {
    if (val === true) {
      setModalEditLocation(false);
      StoreInfoAPIHandler();
      setEditKey(false);
    }
  };

  const uid = parseInt(userId());

  const StoreInfoAPIHandler = async () => {
    const val = {
      bu_id: uid,
      api_method: "get",
    };

    const StoreInfoTableData = await StoreLocationAPI(val);
    if (StoreInfoTableData.status === 429) {
      setLoading(true);
      toast.error(StoreInfoTableData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setstoreInfo(StoreInfoTableData.data);
  };

  const handleDelete = async (flag) => {
    if (flag === true) {
      const val = {
        bu_id: deleteId.bu_id,
        sl_address: deleteId.sl_address,
        sl_state: deleteId.sl_state,
        sl_city: deleteId.sl_city,
        sl_zipcode: deleteId.sl_zipcode,
        storelocation_id: deleteId.storelocation_id,
        key: "delete",
        api_method: "post",
      };
      setBtnLoading(true);
      const filteredList = await StoreLocationAPI(val);
      if (filteredList === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setBtnLoading(false);
      } else {
        if (filteredList.success === true) {
          toast.success(filteredList.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          StoreInfoAPIHandler();
          setModalShow(false);
          setBtnLoading(false);
        } else if (filteredList.status === 429) {
          setLoading(true);
          toast.error(filteredList.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          toast.error(filteredList.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setBtnLoading(false);
        }
      }
    }
  };

  const locationHideHandler = async (checked, storelocationId) => {
    setLocationStatus((prevState) => ({
      ...prevState,
      [storelocationId]: checked,
    }));

    const val = {
      bu_id: uid,
      api_method: "post",
      storelocation_id: storelocationId ? storelocationId : "",
      key: "hide_show",
      store_location_status: checked ? true : false,
    };

    const filteredList = await StoreLocationAPI(val);

    if (filteredList === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      if (filteredList.success === true) {
        toast.success(filteredList.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        StoreInfoAPIHandler();
      } else if (filteredList.status === 429) {
        toast.error(filteredList.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(filteredList.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };

  useEffect(() => {
    StoreInfoAPIHandler();
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="table-responsive-xl black-header mx-5 store-info">
        <h1 className="page-maintitle d-flex justify-content-center orange-text">
          Store Locations <span className="star-required">*</span>
        </h1>

        <p className="info-text-space-f13 justify-content-center">
          &#40;At least one store location business user shall add to apply for
          a marketplace.&#41;
        </p>
        <table className="recentact-table mt-3 table ver-middle manage-vou-table text-center  store-table">

          <thead className="text-white">
            <tr>
              <th>Address</th>
              <th>State/Province</th>
              <th>City</th>
              <th>Zipcode</th>
              <th className="action-main text-white">Actions</th>
            </tr>
          </thead>
          <tbody>
            {storeInfoData?.length > 0
              ? storeInfoData.map((data, i) => {
                  console.log(
                    "qwer",
                    locationStatus[data.storelocation_id],
                    data.show_address_status,
                    data.storelocation_id
                  );
                  return (
                    <tr key={i}>
                      <td
                        className="text-left text-limit-2"
                        title={data.store_address}
                      >
                        {data.store_address}
                      </td>
                      <td>
                        <p className="text-left text-limit-2 state_Inner">
                          {data.state_name}
                        </p>
                      </td>
                      <td>{data.city_name}</td>
                      <td>{data.store_zipcode}</td>
                      <td>
                        <div className="action-img">
                          <Link>
                            <Image
                              loading="lazy"
                              src={editpic}
                              onClick={() => {
                                setModalEditLocation(true);
                                setEditInfo(data);
                                setEdit(true);
                              }}
                            ></Image>
                          </Link>
                          <button
                            onClick={() => {
                              setModalShow(true);
                              setDeleteID(data);
                            }}
                            title="Delete"
                          >
                            <Image loading="lazy" src={deletepic}></Image>
                          </button>
                          <Switch
                            className="switch-button"
                            checkedChildren="Show"
                            unCheckedChildren="Hide"
                            checked={
                              locationStatus[data.storelocation_id] ||
                              data.show_address_status === "True"
                                ? true
                                : false
                            }
                            onChange={(checked) => {
                              locationHideHandler(
                                checked,
                                data.storelocation_id
                              );
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              : ""}
            <tr className="my -4">
              <td colSpan={9} className="table-viewall pt-4">
                <Link
                  type="submit"
                  className="green-btn mt-0 btn btn-primary dotted-btn"
                  onClick={() => setModalShowLocation(true)}
                >
                  Add New Location
                </Link>
                <EditLocationModal
                  show={modalEditLocation}
                  onHide={() => setModalEditLocation(false)}
                  city_id={editInfo.city_id}
                  city_name={editInfo.city_name}
                  state_id={editInfo.state_id}
                  state_name={editInfo.state_name}
                  store_address={editInfo.store_address}
                  store_zipcode={editInfo.store_zipcode}
                  storelocation_id={editInfo.storelocation_id}
                  // editInfo={editInfo}
                  edit={edit}
                  keyfuc={abc}
                  key={setEditKey}
                />
                <AddLocationModal
                  keyfuc={xyz}
                  show={modalShowLocation}
                  onHide={() => setModalShowLocation(false)}
                  // editInfo={editInfo}
                  // edit={edit}
                  key={key}
                />
                <MyVerticallyCenteredModal
                  handleDeleteLocation={handleDelete}
                  show={modalShow}
                  BtnLoading={btnLoading}
                  onHide={() => setModalShow(false)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AddStoreLocation;
